import { useState } from 'react';
import styled from 'styled-components';
import { FilterType } from '../FilterData';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
} from '../filterOptionModal/OptionModal.styles';
import SaveFilterOptionList from './SaveFilterOptionList';
import RegionOption from '../filterOptionModal/RegionOption';
import TotalCategoryOption from '../filterOptionModal/TotalCategoryOption';
import CourtOption from '../filterOptionModal/CourtOption';
import ProgressStatusOption from '../filterOptionModal/ProgressStatusOption';
import BidnoOption from '../filterOptionModal/BidnoOption';
import UseAreaOption from '../filterOptionModal/UseAreaOption';
import SpecialConditionOption from '../filterOptionModal/SpecialConditionOption';
import mySearchOptionService from '../../../service/mySearchOption/mySearchOption';
import TypeOption from '../filterOptionModal/TypeOption';
import CaseNumberOption from '../filterOptionModal/CaseNumberOption';
import SaveOptionModal from './SaveOptionModal';
import DateOption from './DateOption';
import PriceOption from './PriceOption';
import AreaOption from './AreaOption';
import AddressOption from './AddressOption';
import { isLogin } from '../../../utils/auth';

interface Props {
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
  onClose: () => void;
}

function SaveFilter({ filters, setFilters, onClose }: Props) {
  const [openOption, setOpenOption] = useState<
    | null
    | 'type'
    | 'caseNumber'
    | 'region'
    | 'address'
    | 'court'
    | 'itemStatus'
    | 'appraisalPrice'
    | 'minPrice'
    | 'saleDate'
    | 'approvalDate'
    | 'buildingArea'
    | 'landArea'
    | 'bidno'
    | 'progressStatus'
    | 'useArea'
    | 'specialItemCondition'
  >(null);

  const [titleValue, setTitleValue] = useState('');

  const getUnTitle = async (type: string) => {
    try {
      if (!isLogin()) return;
      const res = await mySearchOptionService.list(type);

      if (res.data.length === 0) return '내 검색조건1';
      const regex = /^내 검색조건(\d+)$/;
      let maxNumber = 0;

      res.data.forEach((item: any) => {
        const match = item.title.match(regex);
        if (match) {
          const num = parseInt(match[1], 10);
          if (num > maxNumber) maxNumber = num;
        }
      });

      return `내 검색조건${maxNumber + 1}`;
    } catch (error) {
      console.error('getSearchOptionList 함수에서 에러 발생:', error);
    }
  };

  const saveOption = async () => {
    try {
      let finalTitle = titleValue;

      if (!titleValue) {
        const unTitle = await getUnTitle(filters.type);
        finalTitle = unTitle ?? '내 검색조건';
      }

      const renderCaseNumber = () => {
        if (filters.type === 'a') {
          if (filters.year || filters.caseNumber) {
            return filters.year + '타경' + filters.caseNumber;
          } else {
            return '';
          }
        } else {
          if (filters.caseNumber) return filters.caseNumber;
          return '';
        }
      };
      const result = await mySearchOptionService.save({
        type: filters.type,
        isCourtOrRegion: filters.regionOrCourt,
        court: filters.court,
        region: filters.region
          .map((item) => `${item.sido} ${item.sigungu} ${item.emd}`)
          .join(','),
        search: filters.address,
        search2: renderCaseNumber(),
        search3: '',
        totalCategory: filters.itemStatus.join(','),
        minappraisedValue: Number(filters.appraisalPrice.min),
        maxappraisedValue: Number(filters.appraisalPrice.max),
        minBidPrice: Number(filters.minPrice.min),
        maxBidPrice: Number(filters.minPrice.max),
        minconstructArea: Number(filters.buildingArea.min),
        maxconstructArea: Number(filters.buildingArea.max),
        minlandArea: Number(filters.landArea.min),
        maxlandArea: Number(filters.landArea.max),
        minSaleDate: filters.saleDate.start,
        maxSaleDate: filters.saleDate.end,
        minApprovalDate: filters.approvalDate.start,
        maxApprovalDate: filters.approvalDate.end,
        bidno: filters.bidno,
        bidStatus: filters.progressStatus,
        specialItemCond: filters.specialConditionViewOption,
        specialItem: filters.specialItemCondition.join(','),
        zoning: filters.useArea.join(','),
        sort: '',
        limit: 0,
        offset: 10,
        title: finalTitle,
        save_type: 'Y',
        search_type: filters.type,
      });
      if (result.status === 'success') {
        alert('저장되었습니다.');
        onClose();
      } else {
        alert(result.message);
      }
    } catch (err: any) {
      console.log(err);
      if (
        err.response.data.message === '저장된 검색조건은 5개까지만 가능합니다.'
      ) {
        alert(err.response.data.message);
      } else {
        console.error('saveOption 함수에서 에러 발생:', err);
        alert('저장에 실패했습니다.');
      }
    }
  };

  const closeModal = () => {
    setOpenOption(null);
  };

  const renderModal = () => {
    switch (openOption) {
      case 'type':
        return (
          <TypeOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'caseNumber':
        return (
          <CaseNumberOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'region':
        return (
          <RegionOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
            onlyRegion={true}
          />
        );
      case 'address':
        return (
          <AddressOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'court':
        return (
          <CourtOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'itemStatus':
        return (
          <TotalCategoryOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'progressStatus':
        return (
          <ProgressStatusOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'saleDate':
        return (
          <DateOption
            option="saleDate"
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'approvalDate':
        return (
          <DateOption
            option="approvalDate"
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'appraisalPrice':
        return (
          <PriceOption
            option="appraisalPrice"
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'minPrice':
        return (
          <PriceOption
            option="minPrice"
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'buildingArea':
        return (
          <AreaOption
            option="buildingArea"
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'landArea':
        return (
          <AreaOption
            option="landArea"
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'bidno':
        return (
          <BidnoOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'useArea':
        return (
          <UseAreaOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
      case 'specialItemCondition':
        return (
          <SpecialConditionOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
          />
        );
    }
  };

  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <TitleBox>
          <Title>내 검색조건 저장</Title>
          <img
            src="/assets/images/close/close-dark-gray.svg"
            alt="닫기"
            width={24}
            onClick={onClose}
          />
        </TitleBox>
        <TitleInputBox gap="8px">
          <ColumnBox gap="4px">
            검색조건 제목
            <TitleInput
              placeholder="예) 10억 이하 서울 아파트"
              value={titleValue}
              onChange={(e) => setTitleValue(e.target.value)}
            />
          </ColumnBox>
          <TitleInputDescription>
            <img src="/assets/images/icon/info-16.svg" alt="" />
            검색조건 미 입력시 자동으로 저장됩니다.
          </TitleInputDescription>
        </TitleInputBox>
        {openOption === null && (
          <OptionListBox>
            <SaveFilterOptionList
              filters={filters}
              setOpenOption={setOpenOption}
            />
            <Bottom>
              <ButtonBox>
                <CancleButton onClick={onClose}>취소</CancleButton>
                <ApplyButton onClick={saveOption}>저장</ApplyButton>
              </ButtonBox>
            </Bottom>
          </OptionListBox>
        )}
        {openOption && (
          <SaveOptionModal
            option={openOption}
            onClose={() => setOpenOption(null)}
          >
            {renderModal()}
          </SaveOptionModal>
        )}
      </ModalContainer>
    </ModalOverlay>
  );
}

export default SaveFilter;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ModalContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px -4px 15px 0px #00000040;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  height: 640px;

  display: flex;
  flex-direction: column;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #70737c38;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const ColumnBox = styled.div<{ gap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap && gap};

  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const TitleInputBox = styled(ColumnBox)`
  border-bottom: 1px solid #e1e2e4;
  padding: 24px 16px;
`;

const TitleInput = styled.input`
  border-radius: 8px;
  padding: 12px;
  background-color: #f7f8fc;
  border: none;
  outline: none;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;

  &::placeholder {
    color: #616161;
  }
`;

const TitleInputDescription = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;
`;

const CancleButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #70737c38;
  background-color: #fff;
  font-size: 16px;
  font-weight: 500;
  color: #37383c9c;
  cursor: pointer;
  padding: 14px 16px;
`;

const OptionListBox = styled(ColumnBox)`
  flex: 1;
  overflow-y: auto;
`;
